import { render } from "./VerificationForm.vue?vue&type=template&id=7fb231c3&scoped=true"
import script from "./VerificationForm.vue?vue&type=script&lang=js"
export * from "./VerificationForm.vue?vue&type=script&lang=js"

import "./VerificationForm.vue?vue&type=style&index=0&id=7fb231c3&scoped=true&lang=css"

import exportComponent from "/Users/akosipau/Dropbox/Sites/onboarding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb231c3"]])

export default __exports__